import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class NoParticipantsAvailableError extends ExpectedError {
  static override _class = 'NoParticipantsAvailableError';

  public constructor() {
    super('NoParticipantsAvailableError', { translationKey: 'NO_PARTICIPANTS_AVAILABLE_ERROR' });
  }
}
